<template>
  <div class="qr-scanner">
    <div class="box">
      <div class="line"></div>
      <div class="angle"></div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'cv-scanner',
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
  .qr-scanner {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    .box {
      width: 100%;
      height: 100%;
      max-height: 100%;
      max-width: 100%;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      overflow: hidden;
      z-index: 1001;
      /*border: 0.1rem solid rgba(0, 255, 51, 0.2);*/
    }
    .line {
      height: calc(100% - 2px);
      width: 100%;
      background: linear-gradient(180deg, rgba(0, 255, 51, 0) 80%, #0ec9bb 211%);
      border-bottom: 3px solid #0ec9bb;
      transform: translateY(0);
      animation: radar-beam 1s infinite;
      animation-timing-function: cubic-bezier(0.53, 0, 0.43, 0.99);
      animation-iteration-count: 1000;
      /*animation-delay: 1.4s;*/
    }
  }

  @keyframes radar-beam {
    0% {
      transform: translateY(-100%);
    }

    100% {
      transform: translateY(0);
    }
  }
</style>